import { Box, ListItem, ListItemText, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'

type Props = {
  text: string
  icon: JSX.Element
  onClick: () => void
}

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.grey[600],
    height: '24px',
  },
}))

export function ListItemWithAction({
  text,
  icon,
  onClick,
}: Props): React.ReactElement {
  const [show, setShow] = useState(false)
  const classes = useStyles()
  return (
    <ListItem
      button
      onClick={onClick}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <ListItemText>{text}</ListItemText>
      {show ? <Box className={classes.icon}>{icon}</Box> : null}
    </ListItem>
  )
}
